import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import axios from 'axios';
import { X } from 'lucide-react';
import { API } from '../utils';

const StartAddressModal = ({ appointment, isFirstOfDay, onClose, onUpdate }) => {
  const { t } = useTranslation();
  const [customStartAddress, setCustomStartAddress] = useState(appointment.custom_start_address || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await axios.patch(`${API}/appointments/${appointment.id}/start-address`, {
        custom_start_address: customStartAddress || null
      });
      toast.success(t('appointment.messages.startAddressUpdated') || 'Indirizzo di partenza aggiornato');
      onClose();
      if (onUpdate) onUpdate();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Errore nel salvataggio');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[60] flex items-center justify-center p-4"
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md" onClick={e => e.stopPropagation()}>
        <div className="p-4 border-b flex items-center justify-between">
          <h3 className="font-bold text-gray-800">
            {t('appointment.editStartingPoint') || 'Modifica punto di partenza'}
          </h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X size={20} />
          </button>
        </div>
        <div className="p-4 space-y-4">
          <p className="text-sm text-gray-600">
            {t('appointment.startingPointDescription') || 'Specifica un indirizzo di partenza diverso per questo appuntamento. Lascia vuoto per usare il calcolo automatico.'}
          </p>
          <div className="space-y-3">
            <label className="flex items-start gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50">
              <input type="radio" name="startPointOption" checked={customStartAddress === ""}
                onChange={() => setCustomStartAddress("")} className="mt-1" />
              <div>
                <p className="font-medium text-gray-800">{t('appointment.automaticCalculation') || 'Calcolo automatico'}</p>
                <p className="text-sm text-gray-500">
                  {isFirstOfDay
                    ? (t('appointment.willUseInstallerHome') || "Utilizzera la sede dell'installatore")
                    : (t('appointment.willUsePreviousAppointment') || "Utilizzera la destinazione dell'appuntamento precedente")}
                </p>
              </div>
            </label>
            <label className="flex items-start gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50">
              <input type="radio" name="startPointOption" checked={customStartAddress !== ""}
                onChange={() => setCustomStartAddress(appointment.custom_start_address || "")} className="mt-1" />
              <div className="flex-1">
                <p className="font-medium text-gray-800">{t('appointment.customStartAddress') || 'Indirizzo personalizzato'}</p>
                {customStartAddress !== "" && (
                  <input type="text" value={customStartAddress}
                    onChange={(e) => setCustomStartAddress(e.target.value)}
                    placeholder="Es: Via Roma 10, Milano"
                    className="mt-2 w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" autoFocus />
                )}
              </div>
            </label>
          </div>
          <div className="flex gap-3 pt-2">
            <button onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
              {t('common.cancel') || 'Annulla'}
            </button>
            <button onClick={save} disabled={saving}
              className="flex-1 px-4 py-2 bg-lojack-red text-white rounded-lg hover:bg-red-700 disabled:opacity-50">
              {saving ? '...' : (t('common.save') || 'Salva')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartAddressModal;
